import { isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";
import { isMatchAbbreviation } from "../Types";

import { FiasFlatTypes } from "./FiasFlatTypes";

export function getFlatTypeLongName(flatType: string | number | undefined): string | undefined {
    const stringFlatType = flatType?.toString();
    const flatName = FiasFlatTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.long;
    if (isNullOrEmpty(flatName)) {
        return undefined;
    }
    return flatName;
}

export function getFlatTypeShortName(flatType: string | number | undefined): string | undefined {
    const stringFlatType = flatType?.toString();
    const flatName = FiasFlatTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.short;
    if (isNullOrEmpty(flatName)) {
        return undefined;
    }
    return flatName;
}

export function getFlatTypeObjectID(roomType: string | number | undefined): string | undefined {
    const stringFlatType = roomType?.toString();
    const roomName = FiasFlatTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.objectID;
    if (isNullOrEmpty(roomName)) {
        return undefined;
    }
    return roomName;
}
